import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { Subscription } from 'rxjs';
import { ApiRequest, IApiresponse } from 'src/app/_models';
import { LocationCommonDetail } from 'src/app/_models/claimant-on-web/claimant-on-web';
import { IOrganisationGooglePackageUpdateCallsRequest, OrganisationGooglePackageUpdateCallsRequest } from 'src/app/_models/google-mapping/google-mapping';
import { ClaimsService } from 'src/app/_services/common/claims.service';
import { GoogleMappingService } from 'src/app/_services/google-mapping/google-mapping.service';
import { environment } from 'src/environments/environment';
import { DynamicFormService } from '../../dynamic-form/dynamic-form.service';
import { TranslateService } from "@ngx-translate/core";
import { Claims } from "src/app/_models/common/claims";
import { AlertPanelModel } from 'src/app/_models/common/alertPanelModel';
import { ClaimantOnWebService } from 'src/app/_services/claimant-on-web/claimant-on-web.service';

@Component({
    selector: 'formly-google-location-input',
    templateUrl: "./formly-google-location-input.component.html",
    standalone: false
})
export class FormlyGoogleLocationInputComponent extends FieldType implements OnInit, OnDestroy {

  claimsSubscription: Subscription;
  claims: Claims;

  isFormSubmitted: boolean = false;
  formSubmissionSubscription: Subscription;
  fieldKey: string;

  queryWait: boolean = false;
  googleDynamicAddressList: any;
  isGoogleDropdownVisible: boolean = false;
  isHomeOfcDropdownVisible: boolean = false;
  isGoogleAddressNotFound: boolean = false;
  countOfGoogleCalls: number = 0;

  gm_lable: string;
  modelKey: string;
  isCurrentLocationVisible: boolean = false;

  showLocationPermissionPanel: boolean = false;
  private geolocationPermissionStatus: any;

  constructor(private dynamicFormService: DynamicFormService,
    private claimsService: ClaimsService,
    private googleMappingService: GoogleMappingService,
    private translate: TranslateService,
    private claimantOnWebService: ClaimantOnWebService,
    private cdr: ChangeDetectorRef) {
    super();
    this.claimsSubscription = this.claimsService.currentClaims.subscribe((claims) => {
      this.claims = claims;
    });
  }

  ngOnInit() {
    if (this.field.key) {
      this.fieldKey =this.field.id??this.field.key.toString();
    }
    this.formSubmissionSubscription = this.dynamicFormService.getFormSubmittedEvent().subscribe(data => {
      this.isFormSubmitted = data;
    });
    // UC-6: orgs onboarded with the default 8-char limit show the new "up to N" message; others keep gm_message.
    const gmKey = this.model?.googleCallsInfo?.isLimitCharDefaultSet ? 'mileage_uc_6_msg_1' : 'gm_message';
    this.gm_lable = ' ' + this.translate.instant(gmKey);
    this.modelKey = this.field.templateOptions.modelKey;
    this.fnSetGoogleCallsMsg()
  }

  ngOnDestroy() {
    if (this.formSubmissionSubscription) {
      this.formSubmissionSubscription.unsubscribe();
    }
    if (this.claimsSubscription) {
      this.claimsSubscription.unsubscribe();
    }
    if (this.geolocationPermissionStatus) {
      this.geolocationPermissionStatus.onchange = null;
    }
  }
  fnSetGoogleCallsMsg() {
    if (this.formControl.value) {
      this.isGoogleNotesDisplay = false;
      this.isToDelIconDisplay = true;
    }
  }
  onTextInput() {
    this.model[this.modelKey.toString()].location = this.formControl.value;
    if (this.to.change) {
      this.to.change(this.field, this.formControl.value);
    }

  }
  isCharLimit: boolean = false;
  fnKeypress(value) {
    if (this.isToDelIconDisplay) {
      return false;
    }
    else {
      this.isCharLimit = false;
      if (this.model.googleCallsInfo
        && Number(this.model.googleCallsInfo.limitChar) > 0
        && value.length >= Number(this.model.googleCallsInfo.limitChar)) {
        this.isCharLimit = true;
        return false;
      }
      return true;
    }

  }
  fnKeyDown() {
    if (this.isToDelIconDisplay) {
      return false;
    }
    else {
      return true;
    }
  }
  isToDelIconDisplay: boolean = false;
  fnSearchAddress(value) {
    if (value.length == 0) {
      this.isToDelIconDisplay = false;
    }
    if (this.model.googleCallsInfo
      && Number(this.model.googleCallsInfo.limitChar) > 0
      && value.length <= Number(this.model.googleCallsInfo.limitChar)) {
      this.isCharLimit = false;
    }
    if (!this.isCharLimit) {
      this.isHomeOfcDropdownVisible = false;
      this.isCurrentLocationVisible = false;
      this.model[this.modelKey.toString()].placeId = null;
      this.model[this.modelKey.toString()].location = this.formControl.value;

      if (!this.queryWait) {
        this.queryWait = true;
        setTimeout(() => {
          this.fnGetFromAutocompletePredictions();
          this.queryWait = false;
          //this.cdr.detectChanges();
        }, 200);
      }
    }
    
  }

  private fnGetFromAutocompletePredictions() {

    if (this.model[this.modelKey.toString()].location.length < 6) {
      this.googleDynamicAddressList = null;
      if (this.model[this.modelKey.toString()].location.length > 0) {
        this.isGoogleAddressNotFound = true;
        this.isHomeOfcDropdownVisible = false;
        this.isCurrentLocationVisible = false;
      }
      else {
        if (this.model.triangulationRule) {
          this.isHomeOfcDropdownVisible = true;
          this.isCurrentLocationVisible = true;
        }
        this.isGoogleAddressNotFound = false;
        this.isGoogleDropdownVisible = false;
      }
    }
    if (this.model[this.modelKey.toString()].location.length != 6 && this.model[this.modelKey.toString()].location.length < 10) {
      return;
    }
    this.fnGetPlacePredictions(this.model[this.modelKey.toString()].location)
      .then(data => {
        this.googleDynamicAddressList = data;
        setTimeout(() => {
          this.isGoogleAddressNotFound = this.googleDynamicAddressList == null ? true : false;
          this.isHomeOfcDropdownVisible = false;
          this.isCurrentLocationVisible = false;
          this.isGoogleDropdownVisible = this.googleDynamicAddressList != null ? true : false;
          this.countOfGoogleCalls++;
          this.cdr.detectChanges();
        }, 100);
        
      })
      .catch(err => {
        this.isGoogleDropdownVisible = false;
        this.isGoogleAddressNotFound = true;
        this.isHomeOfcDropdownVisible = false;
        this.isCurrentLocationVisible = false;
      });
  }

  private fnGetPlacePredictions(query: string): Promise<any> {
    let autocompleteSrv = new google.maps.places.AutocompleteService();
    return new Promise((resolve, reject) => {
      autocompleteSrv.getPlacePredictions({
        types: ['geocode'],
        input: query
      }, function (predictions, status) {
        if (status == google.maps.places.PlacesServiceStatus.OK) {
          resolve(predictions);
        } else {
          reject(status);
        }
      });
    });
  }
  fnOnInputClick() {
    if (this.model.triangulationRule) {
      if ((!this.googleDynamicAddressList || this.googleDynamicAddressList == null
        || this.googleDynamicAddressList.length == 0) && (!this.formControl.value || this.formControl.value == '')) {
        this.isGoogleDropdownVisible = false;
        this.isGoogleAddressNotFound = false;
        this.isHomeOfcDropdownVisible = true;
        this.isCurrentLocationVisible = true;
      }
    }
    else if(this.model.currentLocation)
      {
        this.isGoogleDropdownVisible = false;
        this.isGoogleAddressNotFound = false;
        this.isHomeOfcDropdownVisible = false;
        this.isCurrentLocationVisible = true;
      }
  }
  fnCloseGoogleDropdown() {
    setTimeout(() => {
      this.cdr.detectChanges();
      this.isGoogleDropdownVisible = false;
      this.isGoogleAddressNotFound = false;
      this.isHomeOfcDropdownVisible = false;
      this.isCurrentLocationVisible = false;
    }, 300);


    if (!this.isToDelIconDisplay && this.countOfGoogleCalls > 0) {
      this.fnUpdateOrganisationGooglePackageCalls();
    }
  }

  fnUpdateOrganisationGooglePackageCalls() {
    let request = new ApiRequest<IOrganisationGooglePackageUpdateCallsRequest>("UpdateOrganisationGooglePackageCalls", environment.applicationVersion, environment.requestId);
    let requestInfo = new OrganisationGooglePackageUpdateCallsRequest();
    requestInfo.OrganisationId = this.claims.OrgId;
    requestInfo.CallsUsed = this.countOfGoogleCalls;
    requestInfo.UpdatedBy = this.claims.UserId;
    request.requestInfo = requestInfo;
    this.googleMappingService.UpdateOrganisationGooglePackageCalls(request).subscribe((res: IApiresponse<any>) => {
      this.countOfGoogleCalls = 0;
    });
  }
  isGoogleNotesDisplay: boolean = true;
  fnSetAddress(place: object) {
    this.formControl.setValue(place['description']);
    this.model[this.modelKey.toString()].location = place['description'];
    this.model[this.modelKey.toString()].placeId = place['place_id'];
    this.isGoogleNotesDisplay = false;
    this.googleDynamicAddressList = null;
    this.isGoogleAddressNotFound = false;
    this.isHomeOfcDropdownVisible = false;
    this.isCurrentLocationVisible = false;
    this.fnIsDelIconDisplay();
    if (this.to.change) {
      this.to.change(this.field, this.formControl.value);
    }
    setTimeout(() => {
      this.cdr.detectChanges();
      this.isGoogleDropdownVisible = false;
    }, 200);
    
  }
  fnSetAddressFromTriangulation(location: LocationCommonDetail) {
    if (location) {
      this.formControl.setValue(location.address);
      this.model[this.modelKey.toString()].location = location.address;
      this.model[this.modelKey.toString()].placeId = location.placeId;
      this.isGoogleNotesDisplay = false
      this.googleDynamicAddressList = null;
      this.isGoogleAddressNotFound = false;
      this.isHomeOfcDropdownVisible = false;
      this.isCurrentLocationVisible = false;
      this.fnIsDelIconDisplay();
      if (this.to.change) {
        this.to.change(this.field, this.formControl.value);
      }
      setTimeout(() => {
        this.cdr.detectChanges();
        this.isGoogleDropdownVisible = false;
      }, 200);
    }

  }
  fnHandleCurrentLocationClick() {
    // Already have a captured location -> use the existing flow.
    if (this.model.currentLocation) {
      this.fnSetCurrentLocation();
      return;
    }
    this.fnRequestCurrentLocation();
  }

  fnRequestCurrentLocation() {
    // Watch for the user enabling location in browser site settings later, so the row
    // can un-fade live without a page reload.
    this.claimantOnWebService
      .watchGeolocationPermission((state: string) => {
        if (state === "granted" && !this.model.currentLocation) {
          this.fnCaptureCurrentLocation(false);
        }
      })
      .then((status: any) => {
        if (status) {
          this.geolocationPermissionStatus = status;
        }
      });

    this.claimantOnWebService.getGeolocationPermissionState().then((state) => {
      // "denied" cannot be re-prompted -> show instructions; otherwise attempt capture.
      if (state === "denied") {
        this.fnShowLocationPermissionPanel();
      } else {
        this.fnCaptureCurrentLocation(true);
      }
    });
  }

  private fnCaptureCurrentLocation(fill: boolean) {
    this.claimantOnWebService
      .captureCurrentLocation()
      .then((result: any) => {
        this.model.currentLocation = result;
        // Only fill the field when triggered by an explicit click.
        if (fill) {
          this.fnSetCurrentLocation();
        }
        this.showLocationPermissionPanel = false;
        this.cdr.detectChanges();
      })
      .catch((error: any) => {
        // 1 === PERMISSION_DENIED
        if (error && error.code === 1) {
          this.fnShowLocationPermissionPanel();
        }
      });
  }

  fnShowLocationPermissionPanel() {
    this.showLocationPermissionPanel = true;
    this.cdr.detectChanges();
  }

  fnCloseLocationPermissionPanel(event) {
    this.showLocationPermissionPanel = false;
  }

  fnSetCurrentLocation() {
    if (location) {
      this.formControl.setValue(this.model.currentLocation.formatted_address);
      this.model[this.modelKey.toString()].location = this.model.currentLocation.formatted_address;
      this.model[this.modelKey.toString()].placeId = this.model.currentLocation.place_id;
      this.isGoogleNotesDisplay = false
      this.googleDynamicAddressList = null;
      this.isGoogleAddressNotFound = false;
      this.isHomeOfcDropdownVisible = false;
      this.isCurrentLocationVisible = false;
      this.countOfGoogleCalls++;
      this.fnIsDelIconDisplay();
      if (this.to.change) {
        this.to.change(this.field, this.formControl.value);
      }
      setTimeout(() => {
        this.cdr.detectChanges();
        this.isGoogleDropdownVisible = false;
      }, 200);
    }

  }
  fnDeleteText() {
    this.model[this.modelKey.toString()].placeId = null;
    this.model[this.modelKey.toString()].location = null;
    this.isGoogleNotesDisplay = true
    this.formControl.setValue(null);
    if (this.to.change) {
      this.to.change(this.field, this.formControl.value);
    }
    this.cdr.detectChanges();
    this.isToDelIconDisplay = false;
  }
  fnIsDelIconDisplay() {
    this.isToDelIconDisplay = true;
  }

  fnSearchPlacePrediction() {
    this.fnGetPlacePredictions(this.model[this.modelKey.toString()].location)
      .then(data => {
        this.googleDynamicAddressList = data;
        this.isGoogleDropdownVisible = this.googleDynamicAddressList != null ? true : false;
        this.isGoogleAddressNotFound = this.googleDynamicAddressList == null ? true : false;
        this.isHomeOfcDropdownVisible = false;
        this.isCurrentLocationVisible = false;
        this.countOfGoogleCalls++;
      })
      .catch(_err => {
        this.isGoogleDropdownVisible = false;
        this.isGoogleAddressNotFound = true;
        this.isHomeOfcDropdownVisible = false;
        this.isCurrentLocationVisible = false;

      });
  }
  isOfficeAddressPanel: boolean;
  closeOfficeAddPanel(location) {
    if (location) {
      this.formControl.setValue(location.officeAddress);
      this.model[this.modelKey.toString()].location = location.officeAddress;
      this.model[this.modelKey.toString()].placeId = location.placeId;
      this.isGoogleNotesDisplay = false;
      this.googleDynamicAddressList = null;
      this.isGoogleAddressNotFound = false;
      this.isHomeOfcDropdownVisible = false;
      this.isCurrentLocationVisible = false;
      this.fnIsDelIconDisplay();
      if (this.to.change) {
        this.to.change(this.field, this.formControl.value);
      }
      setTimeout(() => {
        this.cdr.detectChanges();
        this.isGoogleDropdownVisible = false;
      }, 200);
    }
    this.isOfficeAddressPanel = false;
  }
}
